import { createRouter, createWebHistory } from 'vue-router'
import { routes as private_routes } from './routes'
import { useTabStore } from '@/stores/tab'
import { Tab } from '@/libs/tab'
import { useMenuStore } from '@/stores/menu'
import { isEqual } from '@/libs/utils/obj-check'
import { useLayoutStore } from '@/stores/layout'
import { useIdentityStore } from '@/stores/identity/auth'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: private_routes,
})

export const routes = private_routes

export function gotoLogin(from: string) {
  const redirect = `/login?from=${encodeURIComponent(from)}`
  console.log(`Requested reauthentication, redirecting to ${redirect}`)
  location.assign(redirect)
}

function shouldCopyQueryFromTab(tab_id: string) {
  switch (tab_id) {
    default:
      return true
  }
}

router.beforeEach(async (to, from, next) => {
  const user_store = useIdentityStore()
  const tab_store = useTabStore()
  const menu_store = useMenuStore()
  const layout_store = useLayoutStore()
  layout_store.set_breadcrumb([{ label: 'Home', path: '/home' }])
  if (to.meta.is_public) {
    return next()
  }
  if (!user_store.is_authenticated) {
    const redirect = `/login?from=${encodeURIComponent(to.fullPath)}`
    console.log(`User not authenticated, redirecting to ${redirect}`)
    next(redirect)
  } else {
    const guard = to.meta.guard as () => boolean
    if (guard && !guard()) {
      return next('/404')
    }
    menu_store.resetMenu()
    let tab = tab_store.findTabById(to.path)
    if (!tab) {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const title = (to.meta.title || ((...arg: any) => 'Not Found')) as (
        ...args: any
      ) => string
      tab = new Tab({
        id: to.path,
        title: title(to.params),
        path: to.path,
        query: to.query,
      })
      tab_store.addTab(tab, true)
    } else tab_store.setActiveTab(tab)
    if (shouldCopyQueryFromTab(tab.id) && !isEqual(to.query, tab.query)) {
      to.query = tab.query ? tab.query : to.query
    } else {
      tab.query = to.query
    }

    const menu = menu_store.menuItems.find(({ path }) => {
      return path === tab?.path
    })
    menu_store.setActiveMenu(menu)
  }
  next()
})
export default router
